import BASE from './base'

export default {
  /** Background **/
  background: BASE.greys.white,
  backgroundHover: BASE.teals.mint,
  backgroundActive: BASE.greys.smoke,
  backgroundDisabled: BASE.greys.gallery,
  backgroundBrand: BASE.blues.midnight,
  backgroundAccent: BASE.blues['pale-blue'],
  backgroundNotify: BASE.yellows.bisque,
  backgroundRisk: BASE.reds.floral,

  /** Texts **/
  text: BASE.greys.mortar,
  textBold: BASE.greys.black,
  textError: BASE.reds.watermelon,
  textHeavy: BASE.blues.midnight,
  textWeak: BASE.greys.grey,

  textAccent: BASE.blues.vivid,
  textAccentBold: BASE.blues.midnight,
  textAccentWeak: BASE.blues.danube,

  textNotify: BASE.yellows.bean,
  textNotifyBold: BASE.yellows.punga,
  textNotifyWeak: BASE.yellows.kumera,

  textRisk: BASE.reds.stiletto,
  textRiskBold: BASE.reds.espresso,
  textRiskWeak: BASE.reds.rust,

  textOnColor: BASE.blues['pale-blue'],
  textOnColorBold: BASE.greys.white,
  textOnColorWeak: BASE.blues.oyster,

  /** Links **/
  link: BASE.teals.atoll,
  linkHover: BASE.teals.moss,
  linkDisabled: BASE.greys.silver,

  linkIcon: BASE.teals['atoll-icons'],
  linkIconActive: BASE.teals.mint,

  linkOnColor: BASE.teals.fountain,
  linkOnColorHover: BASE.teals.mint,

  /** Buttons **/

  button: {
    primary: {
      bg: BASE.teals.atoll,
      bgActive: BASE.teals.moss,
      bgDisabled: BASE.greys.gallery,
      bgHover: BASE.teals.moss,
      border: BASE.teals.atoll,
      borderActive: BASE.teals.atoll,
      borderDisabled: BASE.greys.gallery,
      borderHover: BASE.teals.moss,
      icon: BASE.greys.white,
      iconDisabled: BASE.greys.stone,
      focusInset: BASE.greys.white,
      text: BASE.greys.white,
      textDisabled: BASE.greys.stone,
    },
    secondary: {
      bg: 'transparent',
      bgActive: BASE.teals.mint,
      bgDisabled: 'transparent',
      bgHover: BASE.teals.mint,
      border: BASE.teals.atoll,
      borderActive: BASE.teals.atoll,
      borderDisabled: BASE.greys.stone,
      borderHover: BASE.teals.atoll,
      icon: BASE.teals['atoll-icons'],
      iconDisabled: BASE.greys.silver,
      focusInset: BASE.teals.atoll,
      text: BASE.teals.atoll,
      textDisabled: BASE.greys.silver,
    },
    onColor: {
      bg: BASE.greys.white,
      bgActive: BASE.teals.mint,
      bgDisabled: BASE.blues.oyster,
      bgHover: BASE.teals.mint,
      border: BASE.greys.white,
      borderActive: BASE.greys.white,
      borderDisabled: BASE.blues.oyster,
      borderHover: BASE.teals.mint,
      icon: BASE.teals['atoll-icons'],
      iconDisabled: BASE.teals.fountain,
      focusInset: BASE.teals.atoll,
      text: BASE.teals.atoll,
      textDisabled: BASE.teals.fountain,
    },
    secondaryOnColor: {
      bg: 'transparent',
      bgActive: BASE.blues['dark-pale-blue'],
      bgDisabled: 'transparent',
      bgHover: BASE.blues['dark-pale-blue'],
      border: BASE.teals.fountain,
      borderActive: BASE.teals.fountain,
      borderDisabled: BASE.blues['dark-midnight'],
      borderHover: BASE.teals.fountain,
      icon: BASE.teals.fountain,
      iconDisabled: BASE.blues['dark-midnight'],
      focusInset: BASE.teals.fountain,
      text: BASE.teals.fountain,
      textDisabled: BASE.blues['dark-midnight'],
    },
    accent: {
      bg: BASE.blues.oyster,
      bgActive: BASE.blues.spindle,
      bgDisabled: BASE.blues.oyster,
      bgHover: BASE.blues.spindle,
      border: BASE.blues.oyster,
      borderActive: BASE.blues.oyster,
      borderDisabled: BASE.blues.oyster,
      borderHover: BASE.blues.spindle,
      icon: BASE.blues.midnight,
      iconDisabled: BASE.blues.spindle,
      focusInset: BASE.blues.midnight,
      text: BASE.blues.midnight,
      textDisabled: BASE.blues.spindle,
    },
    notify: {
      bg: BASE.yellows.apricot,
      bgActive: BASE.yellows.saffron,
      bgDisabled: BASE.yellows.apricot,
      bgHover: BASE.yellows.saffron,
      border: BASE.yellows.apricot,
      borderActive: BASE.yellows.apricot,
      borderDisabled: BASE.yellows.apricot,
      borderHover: BASE.yellows.saffron,
      icon: BASE.yellows.bean,
      iconDisabled: BASE.yellows.saffron,
      focusInset: BASE.yellows.bean,
      text: BASE.yellows.bean,
      textDisabled: BASE.yellows.saffron,
    },
    risk: {
      bg: BASE.reds.cupid,
      bgActive: BASE.reds.blush,
      bgDisabled: BASE.reds.cupid,
      bgHover: BASE.reds.blush,
      border: BASE.reds.cupid,
      borderActive: BASE.reds.cupid,
      borderDisabled: BASE.reds.cupid,
      borderHover: BASE.reds.blush,
      icon: BASE.reds.rust,
      iconDisabled: BASE.reds.blush,
      focusInset: BASE.reds.rust,
      text: BASE.reds.stiletto,
      textDisabled: BASE.reds.blush,
    },
    highRisk: {
      bg: BASE.reds.watermelon,
      bgActive: BASE.reds.amaranth,
      bgDisabled: BASE.reds.blush,
      bgHover: BASE.reds.amaranth,
      border: BASE.reds.watermelon,
      borderActive: BASE.reds.watermelon,
      borderDisabled: BASE.reds.blush,
      borderHover: BASE.reds.amaranth,
      icon: BASE.greys.white,
      iconDisabled: BASE.greys.white,
      focusInset: BASE.greys.white,
      text: BASE.greys.white,
      textDisabled: BASE.greys.white,
    },
  },

  // TODO: deprecate soon
  buttonPrimary: BASE.teals.atoll,
  buttonPrimaryHover: BASE.teals.moss,
  buttonPrimaryActive: BASE.teals.moss,
  buttonPrimaryDisabled: BASE.greys.gallery,
  buttonPrimaryText: BASE.greys.white,
  buttonPrimaryTextDisabled: BASE.greys.stone,
  buttonPrimaryFocusedInset: BASE.greys.white,
  buttonPrimaryBorder: BASE.teals.atoll,

  buttonSecondary: BASE.teals.atoll,
  buttonSecondaryHover: BASE.teals.mint,
  buttonSecondaryActive: BASE.teals.mint,
  buttonSecondaryDisabled: BASE.greys.stone,
  buttonSecondaryText: BASE.teals.atoll,
  buttonSecondaryTextDisabled: BASE.greys.silver,
  buttonSecondaryIcon: BASE.teals['atoll-icons'],
  buttonSecondaryIconDisabled: BASE.greys.silver,
  buttonSecondaryFocusedInset: BASE.teals.atoll,

  buttonPrimaryOnColor: BASE.greys.white,
  buttonPrimaryOnColorHover: BASE.teals.mint,
  buttonPrimaryOnColorActive: BASE.teals.mint,
  buttonPrimaryOnColorDisabled: BASE.blues.oyster,
  buttonPrimaryOnColorText: BASE.teals.atoll,
  buttonPrimaryOnColorTextDisabled: BASE.teals.fountain,
  buttonPrimaryOnColorIcon: BASE.teals['atoll-icons'],
  buttonPrimaryOnColorIconDisabled: BASE.teals.fountain,

  buttonSecondaryOnColor: BASE.teals.fountain,
  buttonSecondaryOnColorHover: BASE.teals.aquamarine,
  buttonSecondaryOnColorActive: BASE.teals.aquamarine,
  buttonSecondaryOnColorDisabled: BASE.blues.oyster,
  buttonSecondaryOnColorText: BASE.teals.fountain,
  buttonSecondaryOnColorTextDisabled: BASE.blues.oyster,

  buttonAccent: BASE.blues.oyster,
  buttonAccentHover: BASE.blues.spindle,
  buttonAccentActive: BASE.blues.spindle,
  buttonAccentDisabled: BASE.blues.oyster,
  buttonAccentText: BASE.blues.midnight,
  buttonAccentTextDisabled: BASE.blues.spindle,
  buttonAccentFocusedInset: BASE.blues.midnight,
  buttonAccentPressedBorder: BASE.blues.oyster,

  buttonNotify: BASE.yellows.apricot,
  buttonNotifyHover: BASE.yellows.saffron,
  buttonNotifyActive: BASE.yellows.saffron,
  buttonNotifyDisabled: BASE.yellows.apricot,
  buttonNotifyText: BASE.yellows.bean,
  buttonNotifyTextDisabled: BASE.yellows.saffron,
  buttonNotifyFocusedInset: BASE.yellows.bean,
  buttonNotifyActiveBorder: BASE.yellows.apricot,

  buttonRisk: BASE.reds.cupid,
  buttonRiskHover: BASE.reds.blush,
  buttonRiskActive: BASE.reds.blush,
  buttonRiskDisabled: BASE.reds.floral,
  buttonRiskText: BASE.reds.stiletto,
  buttonRiskTextDisabled: BASE.reds.blush,
  buttonRiskIcon: BASE.reds.rust,
  buttonRiskFocusedInset: BASE.reds.rust,
  buttonRiskActiveBorder: BASE.reds.cupid,

  buttonHighRisk: BASE.reds.watermelon,
  buttonHighRiskHover: BASE.reds.amaranth,
  buttonHighRiskActive: BASE.reds.amaranth,
  buttonHighRiskDisabled: BASE.reds.blush,
  buttonHighRiskText: BASE.greys.white,
  buttonHighRiskTextDisabled: BASE.greys.white,
  buttonHighRiskFocusedInset: BASE.greys.white,
  buttonHighRiskActiveBorder: BASE.reds.watermelon,

  /** Boarders **/
  border: BASE.greys.silver,
  borderHover: BASE.greys.mortar,
  borderActive: BASE.teals.aquamarine,
  borderDisabled: BASE.greys.stone,
  borderAccent: BASE.blues.vivid,
  borderNotify: BASE.yellows.saffron,
  borderRisk: BASE.reds.watermelon,

  /** Icons **/
  icon: BASE.greys.silver,
  iconHover: BASE.greys.mortar,
  iconDisabled: BASE.greys.stone,

  iconWeak: BASE.greys.stone,
  iconWeakHover: BASE.greys.silver,
  iconWeakDisabled: BASE.greys.gallery,

  iconOnColor: BASE.greys.white,
  iconOnColorHover: BASE.blues.oyster,
  iconOnColorDisabled: BASE.blues.vivid,

  iconButtonOnColor: BASE.teals.fountain,
  iconButtonOnColorDisabled: BASE.blues.oyster,

  iconAccent: BASE.blues.vivid,
  iconAccentHover: BASE.blues.midnight,
  iconAccentDisabled: BASE.blues.oyster,

  iconNotify: BASE.yellows.bean,
  iconNotifyHover: BASE.yellows.punga,
  iconNotifyDisabled: BASE.yellows.saffron,

  iconRisk: BASE.reds.stiletto,
  iconRiskHover: BASE.reds.espresso,
  iconRiskDisabled: BASE.reds.blush,

  /** Support pills **/
  supportInfo: BASE.greys.silver,
  supportEngage: BASE.teals.atoll,
  supportAccent: BASE.blues.vivid,
  supportNotify: BASE.yellows.saffron,
  supportRisk: BASE.reds.amaranth,
  supportText: BASE.greys.white,

  /** Fields **/
  fieldBackground: BASE.greys.white,
  fieldBackgroundAccent: BASE.blues['pale-blue'],
  fieldLabel: BASE.teals.atoll,
  fieldIcon: BASE.greys.silver,
  fieldPlaceholder: BASE.greys.stone,

  /** Booleans **/
  boolean: BASE.teals.aquamarine,
  booleanHover: BASE.teals.atoll,
  booleanActive: BASE.teals.atoll,
  booleanDisabled: BASE.greys.silver,

  /** Misc **/
  overlay: '#24272e7a', // greys.black at 48% opacity
  shLogo: BASE.blues.midnight,
}
